var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.actions",fn:function({ item }){return [_c('v-btn',{attrs:{"text":"","color":"green"},on:{"click":function($event){return _vm.goToChangeDetails(item)}}},[_vm._v("Show")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }